import { ChapterIndexProps } from './types';

export const ChapterIndex = ({ index }: ChapterIndexProps) => <td className="pl-0 py-2.5 pr-2 text-right" data-testid="chapterIndex">{`${index}.`}</td>;
